import PropTypes from 'prop-types'
import { LogBookModes } from '../../models/logbook/log-book-modes-enum'

const { BUSINESS, COMMUTE, PRIVATE } = LogBookModes

/**
 * @typedef {Object} ObjectAvailabilityDetails
 * @property {boolean} [driverLoggedOn] - Indicates if a drive is logged on
 * @property {boolean} [hasActiveOrder] - Indicates if an order is assigned to the object
 * @property {number} [inactiveDays] - Days of inactivity
 * @property {string} [logbookMode] - Indicates which logbookMode is selected
 * @property {boolean} [tachographConnected] - Indicates if the tachograph is connected
 */
export const objectAvailabilityDetailsPropType = PropTypes.shape({
    driverLoggedOn: PropTypes.bool,
    hasActiveOrder: PropTypes.bool,
    inactiveDays: PropTypes.number,
    logbookMode: PropTypes.oneOf([BUSINESS, COMMUTE, PRIVATE]),
    tachographConnected: PropTypes.bool
})
